var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0L16 16H0V0Z","fill":"#303133"}}),_c('path',{attrs:{"d":"M4 8L8 12","stroke":"white"}}),_c('path',{attrs:{"d":"M4 10L6 12","stroke":"white"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }